import { AppConfig } from '../models';

export const DEFAULT_CONFIG: Partial<AppConfig> = {
  uploadFileSizeMbLimit: 1024,
  maxBulkUploadFilesLimit: 500,
  maxConcurrentUploadsLimit: 5,
};
